import * as d3 from 'd3';
import { dN_Rect } from './d_rect';
import { drawMixedShape } from './drawArch';
import { drawArchGridShape } from './drawArchGrid';
import { drawColonialGrillsInMixedShape } from './drawColonialGrillsInMixedShape';
import { drawRadialGrillsInMixedShape } from './drawColonialGrillsInMixedShape';
import { getGlassDesign } from './glassPatternsDefs';


export function drawTwoRowsSections(
    gap = 2,
    initX = 20,
    initY = 20,
    nSections = 5,
    svg,
    frameWidth = 10,
    doorData = null
  ) {
    const finishColor = doorData.flipped ? doorData?.finish?.exteriorColor?.value || 'white' :
                                           doorData?.finish?.interiorColor?.value || 'white' ;
    const grillsColor = doorData.flipped ? doorData?.grills?.exteriorFinish.value || 'white' :
                                           doorData?.grills?.interiorFinish.value || 'white' ;                                       
    const frameData = doorData?.frameData;
  
    const uHeight_d = parseFloat(frameData?.uHeight_d || 0); // upper section height
    const bHeight = parseFloat(frameData?.windowHeight_d || 100); // bottom section height
    const totalHeight = uHeight_d + bHeight; // ✅ total height = both
  
    const hashSize = {
      '5/16"': 0.8,   // 0.3125
      '5/8"': 1.5,    // 0.625
      '3/4"': 2,      // 0.75
      '7/8"': 2.5,    // 0.875
      '1"': 3,        // 1.0
      '1 1/4"': 3.5,  // 1.25
      '2"': 4         // 2.0
    };
    let offsetY = initY;

    const hRect = parseFloat(frameData?.archLegHeight_d) ;
  
    // ✅ CASE 1: Render upper section
    if (uHeight_d > 0) {
      let upperRects = [];
        
      if (frameData?.upperSection === 1) {
        //console.log("frameData?.topRowConf:>", frameData?.topRowConf);
        const topWidth = parseFloat(frameData?.uWidth1_d) || 100;
        const topRowShape = frameData?.topRowConf;
        switch (topRowShape) {
          case "Arch":
          case "ArchBar":
            // Draw 1 section arch
            //const hRect = parseFloat(frameData?.archLegHeight_d);
            const glassDesign = getGlassDesign(doorData);
            drawMixedShape(svg, initX, offsetY - 1,
              /*w:*/         topWidth - 2 * frameWidth - 2*gap + parseInt(nSections),
              /*hRect*/      hRect,
              /*archHeight*/ uHeight_d - hRect,
              frameWidth, /*framColor*/finishColor,
              'black', 'black', 1,
              doorData?.glass?.glassType1.value  || '#EDF9FF',
              doorData?.frameData?.archBar || false,
              doorData?.glass?.glassType1.label,
              glassDesign);

            //-->

            if(doorData?.grills?.archGrillType.value !== 'None' &&
              doorData?.grills?.archGrillPattern?.value === 'Colonial'){
              drawColonialGrillsInMixedShape(
                svg,
                initX,
                offsetY - 1,
                topWidth - 2 * frameWidth - 2 * gap + parseInt(nSections),
                uHeight_d,          // total height (arch + rect)
                frameWidth,
                parseInt(doorData?.grills?.archHorizontalGrills) || 0,                // horLines
                parseInt(doorData?.grills?.archVerticalGrills) || 0,                // verLines
                grillsColor,
                hashSize[doorData?.grills?.archGrillSize] || 3,
                uHeight_d - hRect,        // pass: archHeight = uHeight - hRect
                'black',    // outline color
                0.1         // outline width (thin border)
              );
            }

            if(doorData?.grills?.archGrillType.value !== 'None' &&
              doorData?.grills?.archGrillPattern?.value === 'Rays'){
                drawRadialGrillsInMixedShape(
                svg,
                initX,
                offsetY - 1,
                topWidth - 2 * frameWidth - 2 * gap + parseInt(nSections),
                uHeight_d,          // total height (arch + rect)
                frameWidth,
                parseInt(doorData?.grills?.archRaysGrills) || 0,
                grillsColor,
                hashSize[doorData?.grills?.archGrillSize] || 3,
                uHeight_d - hRect,        // pass: archHeight = uHeight - hRect
                'black',    // outline color
                0.1         // outline width (thin border)
              );
            }

            if (0) {
              drawColonialGrillsInMixedShape(
                svg,
                initX,
                offsetY - 1,
                topWidth - 2 * frameWidth - 2 * gap + parseInt(nSections),
                uHeight_d,          // total height (arch + rect)
                frameWidth,
                4,          // horLines
                4,          // verLines
                'red',    // grill bar fill color
                2,          // grill bar thickness
                50,         // archHeight
                'black',    // outline color
                0.5         // outline width (thin border)
              );
            }
            //--> ^^^
            break;

          case "ArchGrid":
            console.log("entered to 'ArchGrid':" );
            // Draw arch with vertical dividers using drawMixedShapeGrid
            const hRectGrid = hRect; //parseFloat(frameData?.archLegHeight_d);
            const glassDesignGrid = getGlassDesign(doorData);

            // Get actual section widths from frameData
            const sectionWidths = [];
            for (let i = 1; i <= nSections; i++) {
              const key = `windowWidth${i}_d`;
              const width = parseFloat(frameData?.[key]) || 50;
              sectionWidths.push(width);
            }

            // colNumber = number of dividers = sectionWidths.length - 1
            const colNumber = sectionWidths.length - 1;

            // Draw the arch with grid dividers
            drawArchGridShape(
              svg,
              initX,
              offsetY - 1,
              /*w:*/         topWidth - 2 * frameWidth - 2*gap + parseInt(nSections),
              /*hRect*/      hRectGrid,
              /*archHeight*/ uHeight_d - hRectGrid,
              frameWidth,
              /*framColor*/  finishColor,
              'black',
              'black',
              1,
              doorData?.glass?.glassType1.value || '#EDF9FF',
              doorData?.frameData?.archBar || false,
              doorData?.glass?.glassType1.label,
              glassDesignGrid,
              colNumber,      // Number of sections (0 if only 1 section)
              sectionWidths,  // Array of actual section widths (not used anymore)
              doorData,       // Pass doorData to get section widths
              nSections,      // Number of sections
              gap             // Gap between elements
            );

            //-->
            if (false){ //currently no grills for ArchGrid 
              if(doorData?.grills?.archGrillType.value !== 'None' &&
                doorData?.grills?.archGrillPattern?.value === 'Colonial'){
                drawColonialGrillsInMixedShape(
                  svg,
                  initX,
                  offsetY - 1,
                  topWidth - 2 * frameWidth - 2 * gap + parseInt(nSections),
                  uHeight_d,          // total height (arch + rect)
                  frameWidth,
                  parseInt(doorData?.grills?.archHorizontalGrills) || 0,
                  parseInt(doorData?.grills?.archVerticalGrills) || 0,
                  grillsColor,
                  hashSize[doorData?.grills?.archGrillSize] || 3,
                  uHeight_d - hRectGrid,
                  'black',    // outline color
                  0.1         // outline width (thin border)
                );
              }
            }

            if (false){ //currently no grills for ArchGrid 
              if(doorData?.grills?.archGrillType.value !== 'None' &&
                doorData?.grills?.archGrillPattern?.value === 'Rays'){
                  drawRadialGrillsInMixedShape(
                  svg,
                  initX,
                  offsetY - 1,
                  topWidth - 2 * frameWidth - 2 * gap + parseInt(nSections),
                  uHeight_d,          // total height (arch + rect)
                  frameWidth,
                  parseInt(doorData?.grills?.archRaysGrills) || 0,
                  grillsColor,
                  hashSize[doorData?.grills?.archGrillSize] || 3,
                  uHeight_d - hRectGrid,
                  'black',    // outline color
                  0.1         // outline width (thin border)
                );
              }
            }

            if (0) {
              drawColonialGrillsInMixedShape(
                svg,
                initX,
                offsetY - 1,
                totalArchGridWidth - 2 * frameWidth - 2 * gap + parseInt(nSections),
                uHeight_d,          // total height (arch + rect)
                frameWidth,
                4,          // horLines
                4,          // verLines
                'red',    // grill bar fill color
                2,          // grill bar thickness
                50,         // archHeight
                'black',    // outline color
                0.5         // outline width (thin border)
              );
            }
            //--> ^^^
            break;

          case "Grid":
            // Grid case - currently falls through to default
            // TODO: Implement Grid-specific rendering if needed
            // For now, render as rectangle (default behavior)
            upperRects = [{
              w: topWidth - 2 * frameWidth - 2*gap + parseInt(nSections),
              h: uHeight_d,
              frameWidth,
              frameColor: finishColor,
              lineFrameColor: 'black',
              lineFrameThickness: 1,
              outerStrokeColor: 'black',
              outerStrokeWidth: 1,
              color: '#EDF9FF'
            }];
            break;

          case "1 Section":
          default:
            // Draw 1 section rectangle
            upperRects = [{
              w: topWidth - 2 * frameWidth - 2*gap + parseInt(nSections),
              h: uHeight_d,
              frameWidth,
              frameColor: finishColor,
              lineFrameColor: 'black',
              lineFrameThickness: 1,
              outerStrokeColor: 'black',
              outerStrokeWidth: 1,
              color: '#EDF9FF'
            }];
            break;
        }
      } else {
        for (let i = 1; i <= nSections; i++) {
          const key = `windowWidth${i}_d`;
          const width = parseFloat(frameData?.[key]) || 50;
          const upperKey = `uWidth${i}_d`;
          frameData[upperKey] = width;
  
          upperRects.push({
            w: width,
            h: uHeight_d,
            frameWidth,
            frameColor: finishColor,
            lineFrameColor: 'black',
            lineFrameThickness: 1,
            outerStrokeColor: 'black',
            outerStrokeWidth: 1,
            color: '#EDF9FF'
          });
        }
      }
  
      dN_Rect(svg, gap, initX, offsetY + gap - gap - 1 , upperRects, {
        labelText: null,
        labelOptions: {
          fontSize: 36,
          fontColor: 'black',
          fontOpacity: 0.2
        },
        drawFrame: true
      });
  
      offsetY += uHeight_d + gap + 2 * frameWidth;
    }
  
    // ✅ CASE 2: Bottom row
    const bottomRects = [];
    const bottomHeight = bHeight;
  
    for (let i = 1; i <= nSections; i++) {
      const key = `windowWidth${i}_d`;
      const width = parseFloat(frameData?.[key]) || 50;
  
      bottomRects.push({
        w: width,
        h: bottomHeight,
        frameWidth,
        frameColor: finishColor,
        lineFrameColor: 'black',
        lineFrameThickness: 1,
        outerStrokeColor: 'black',
        outerStrokeWidth: 1,
        color: '#EDF9FF'
      });
    }
  
    dN_Rect(svg, gap, initX, offsetY, bottomRects, {
      labelText: null,
      labelOptions: {
        fontSize: 36,
        fontColor: 'black',
        fontOpacity: 0.2
      },
      drawFrame: true
    });
  }
  


